import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  Alert,
  Tabs,
  Tab,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Cookie from "cookie-universal";
import { CLIENTS } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";

function ClientsCreate() {
  const [tabIndex, setTabIndex] = useState(0);
  const [titleEn, setTitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [image, setImage] = useState(null);
  const [alert, setAlert] = useState(null);
  const [alertVisible, setAlertVisible] = useState(true);

  const token = Cookie().get("dashboardLogin");
  const userRole = Cookie().get("userRole");

  const fetchClients = async () => {
    try {
      const response = await Axios.get(`/panel/${CLIENTS}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });
      console.log("Fetched Clients:", response.data);
      setTitleEn(response.data.titleen || "");
      setTitleAr(response.data.titlear || "");
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title_en", titleEn);
    formData.append("title_ar", titleAr);
    if (image) formData.append("image", image);

    try {
      await Axios.post(`/panel/${CLIENTS}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
          "Content-Type": "multipart/form-data",
        },
      });

      fetchClients();
      setTitleEn("");
      setTitleAr("");
      setImage(null);
      setAlert({ type: "success", message: "Client added successfully!" });
      setTimeout(() => setAlertVisible(false), 2000);
      setAlertVisible(true);
    } catch (error) {
      console.error("Error adding client:", error);
      setAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to add client.",
      });
      setTimeout(() => setAlertVisible(false), 2000);
      setAlertVisible(true);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  return (
    <>
      {alert && alertVisible && (
        <Alert
          severity={alert.type} // Ensure this uses 'type' instead of 'severity'
          onClose={() => setAlertVisible(false)}
          sx={{
            transition: "opacity 1s ease-out",
            opacity: alertVisible ? 1 : 0,
          }}
        >
          {alert.message}
        </Alert>
      )}

      <Grid size={12}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mx: "auto", p: 2, boxShadow: 3, borderRadius: 2 }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, newIndex) => setTabIndex(newIndex)}
            centered
          >
            <Tab label="English" />
            <Tab label="العربية" />
          </Tabs>

          {tabIndex === 0 && (
            <TextField
              fullWidth
              margin="normal"
              label="Title (English)"
              value={titleEn}
              onChange={(e) => setTitleEn(e.target.value)}
            />
          )}
          {tabIndex === 1 && (
            <TextField
              fullWidth
              margin="normal"
              label="العنوان"
              value={titleAr}
              onChange={(e) => setTitleAr(e.target.value)}
            />
          )}

          {/* Beautiful Upload Box */}
          <Box
            sx={{
              border: "2px dashed #1976d2",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              cursor: "pointer",
              position: "relative",
              bgcolor: "#f0f8ff",
              "&:hover": { bgcolor: "#e3f2fd" },
            }}
          >
            <input
              type="file"
              accept="image/*"
              style={{
                opacity: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                cursor: "pointer",
              }}
              onChange={handleImageChange}
            />
            <CloudUploadIcon sx={{ fontSize: 50, color: "#1976d2" }} />
            <Typography variant="body1" color="primary">
              Click or Drag to Upload Image
            </Typography>
          </Box>

          {/* Show selected image preview */}
          {image && (
            <Box mt={2} textAlign="center">
              <Typography variant="body2">{image.name}</Typography>
              <img
                src={URL.createObjectURL(image)}
                alt="Preview"
                style={{
                  width: "20%",
                  height: "auto",
                  borderRadius: 8,
                  marginTop: 10,
                }}
              />
            </Box>
          )}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    </>
  );
}

export default ClientsCreate;
